import z, {ZodTypeAny, ZodString, ZodArray} from 'zod';

import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {unwrapField} from './unwrapField';

const requiredMessage = {message: i18n.t('general.errors.mixed.required')};

export function makeFieldRequired(field: ZodTypeAny): ZodTypeAny {
  const {unwrappedField} = unwrapField(field);

  return z
    .any()
    .superRefine((val, ctx) => {
      const coreType = unwrappedField._def.schema ?? unwrappedField;
      let isInvalid = false;

      if (coreType instanceof ZodString) {
        isInvalid = isNilOrEmpty(val) || val === 'null';
      } else if (coreType instanceof ZodArray) {
        isInvalid = isNilOrEmpty(val);
      } else {
        isInvalid = val == null;
      }

      if (isInvalid) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: requiredMessage.message,
        });

        return z.NEVER;
      }
    })
    .transform((val) => unwrappedField.parse(val));
}
